import React from "react";
import styles from "./Specifications.module.css";
import PreLoader from "../../../components/PreLoader/PreLoader";
import { li } from "framer-motion/client";

const Specifications = ({ specifications }) => {
  if (!specifications) return <PreLoader />;
  console.log(specifications);
  return (
    <>
      <div className={`${styles.specCont}`}>
        <ul className={`${styles.specifications}`}>
          <li>
            <span className={`${styles.specKey}`}>مشخصات</span> :{" "}
            <span className={`${styles.specValue}`}>
              {specifications.status1}
            </span>
          </li>
          <li>
            <span className={`${styles.specKey}`}>مشخصات</span> :{" "}
            <span className={`${styles.specValue}`}>
              {specifications.status2}
            </span>
          </li>{" "}
          <li>
            <span className={`${styles.specKey}`}>مشخصات</span> :{" "}
            <span className={`${styles.specValue}`}>
              {specifications.status3}
            </span>
          </li>{" "}
          <li>
            <span className={`${styles.specKey}`}>مشخصات</span> :{" "}
            <span className={`${styles.specValue}`}>
              {specifications.status4}
            </span>
          </li>{" "}
          <li>
            <span className={`${styles.specKey}`}>مشخصات</span> :{" "}
            <span className={`${styles.specValue}`}>
              {specifications.status5}
            </span>
          </li>{" "}
          <li>
            <span className={`${styles.specKey}`}>مشخصات</span> :{" "}
            <span className={`${styles.specValue}`}>
              {specifications.status6}
            </span>
          </li>
        </ul>
      </div>
    </>
  );
};
export default Specifications;
